import { render, staticRenderFns } from "./AskMessage.vue?vue&type=template&id=7cc49e89&scoped=true&"
import script from "./AskMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskMessage.vue?vue&type=style&index=0&id=7cc49e89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc49e89",
  null
  
)

export default component.exports